import { errorCodeList } from "../Config/error.config";
import { cannotBeInName, specialChars } from "../Config/global.config";
import { overallActions } from "../MainLayout/services/slice";
import { mainRouteEnum } from "../Types/routes.type";

export default class Util {
  static showCodeMessWithModal = (res: any, dispatch: any) => {
    // dispatch({ type: "LOGOUT" });
    const errorCodeArray = Object.keys(errorCodeList);
    const errorMessArray = Object.values(errorCodeList);
    const found = errorCodeArray.find((a) => a === res.errorCode.toString());
    if (found)
      dispatch(
        overallActions.setErrorMess(
          errorMessArray[errorCodeArray.indexOf(found)]
        )
      );
    else dispatch(overallActions.setErrorMess(res.message));
  };

  static checkValidatedEmail = (email: string) => {
    let haveOneAtSymbol = false;
    let haveTwoMoreDomains = false;
    let checkMainEmail = false;
    let checkDomains = false;
    let noSpace = false;

    if (email.includes("@")) {
      if (email.slice(email.indexOf("@") + 1).includes("@"))
        haveOneAtSymbol = false;
      else haveOneAtSymbol = true;
    } else haveOneAtSymbol = false;

    if (email.includes("@")) {
      if (email.slice(email.indexOf("@") + 1).includes("."))
        haveTwoMoreDomains = true;
      else haveTwoMoreDomains = false;
    }

    if (email.includes("@")) {
      const mainEmail = email.slice(0, email.indexOf("@"));
      if (mainEmail.split("").some((a) => cannotBeInName.includes(a)))
        checkMainEmail = false;
      else checkMainEmail = true;
    }

    if (email.includes("@")) {
      const domains = email.slice(email.indexOf("@") + 1).split(".");

      if (
        domains.some((a) => a.split("").some((b) => specialChars.includes(b)))
      )
        checkDomains = false;
      else if (domains[domains.length - 1].length < 2) checkDomains = false;
      else checkDomains = true;
    }

    if (email.split("").some((a) => a === " ")) noSpace = false;
    else noSpace = true;

    return (
      haveOneAtSymbol &&
      haveTwoMoreDomains &&
      checkMainEmail &&
      checkDomains &&
      noSpace
    );
  };

  static formatNumberWithFixedAndComma(money: any, fixed: number) {
    if (typeof Number(money) != "number") {
      return "0";
    }
    const fixedMoney = Number(money).toString();
    const beforeDot =
      fixedMoney.indexOf(".") !== -1
        ? fixedMoney.slice(0, fixedMoney.indexOf("."))
        : fixedMoney;
    let afterDot =
      fixedMoney.indexOf(".") !== -1
        ? fixedMoney.slice(fixedMoney.indexOf(".") + 1)
        : "";

    if (afterDot.length < fixed)
      while (afterDot.length < fixed) afterDot += "0";
    else if (afterDot.length > fixed) {
      if (Number(afterDot[fixed]) >= 5)
        afterDot = (Number(afterDot.slice(0, fixed)) + 1).toString();
      else afterDot = afterDot.slice(0, fixed);
    }

    const finalBeforeDot = `${beforeDot.replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      "$1,"
    )}`;

    if (fixed === 0) return finalBeforeDot;
    return `${finalBeforeDot}.${afterDot}`;
  }

  static get(data: string | null | undefined, trans: object) {
    if (!data) return "";
    const keys = Object.keys(trans).map((a) => a.toString());
    const values = Object.values(trans).map((a) => a.toString());
    const index = keys.indexOf(data);
    if (index !== -1) return values[index];
    return "";
  }

  static getBackVer(data: string | null | undefined, trans: object) {
    if (!data) return "";
    const keys = Object.keys(trans).map((a) => a.toString());
    const values = Object.values(trans).map((a) => a.toString());
    const index = values.indexOf(data);
    if (index !== -1) return keys[index];
    return "";
  }

  static convertToUnaccentedVietnamese(text: string) {
    const charMap = [
      {
        value: "ùúủũụưừứửữự",
        trans: "u",
      },
      {
        value: "èéẻẽẹêềếểễệ",
        trans: "e",
      },
      {
        value: "òóỏõọôồốổỗộơờớởỡợ",
        trans: "o",
      },
      {
        value: "àáảãạâầấẩẫậăằắẳẵặ",
        trans: "a",
      },
      {
        value: "ìíỉĩị",
        trans: "i",
      },
      {
        value: "ỳýỷỹỵ",
        trans: "y",
      },
      {
        value: "dđ",
        trans: "d",
      },
    ];

    const result = [];
    if (text)
      for (let i = 0; i < text.length; i++) {
        const charRaw = text[i];
        const char = charRaw.toLocaleLowerCase();
        const found = charMap.find((a) => a.value.includes(char));
        if (found)
          switch (true) {
            case char === charRaw:
              result.push(found.trans);
              break;

            default:
              result.push(found.trans.toLocaleUpperCase());
          }
        else result.push(charRaw);
      }

    return result.join("");
  }

  static getUniqueData(data: any[], key: string) {
    return data.filter(
      (obj, index, self) => index === self.findIndex((o) => o[key] === obj[key])
    );
  }

  static getByQuery(query: string[]) {
    const params = new URLSearchParams(window.location.search);
    const ans: any = {};
    query.forEach((a) => {
      const found = params.get(a);
      ans[a] = found;
    });
    return ans;
  }

  static handleNavigate(navigate: any, path?: string) {
    navigate(`/${path ? path : mainRouteEnum.home}${window.location.search}`);
  }

  static isValidURL(url: string) {
    try {
      new URL(url);
      return true; // URL hợp lệ
    } catch (e) {
      return false; // URL không hợp lệ
    }
  }

  static checkCampuchiaPhone = (phone: string) => {
    const regex = /^(?:0|\+855)(1[^9]|3[18]|6[^2-5]|7[016-8]|8[^2]|9[^4])\d{6,7}$/;
    return regex.test(phone);
  }
  

  static checkValidatedPhone = (phone: string) => {
    // const headArrRaw = headPhoneNumber.map((a) => a.heads);
    // let headArr: string[] = [];
    // headArrRaw.forEach((a) => (headArr = [...headArr, ...a]));

    let checkLength = false;
    let checkChars = false;
    let checkFirstChar = false;
    let noSpace = false;
    // let checkHead = false;

    if (phone.length === 10) checkLength = true;
    else checkLength = false;

    if (phone.split("").some((a) => isNaN(Number(a)))) checkChars = false;
    else checkChars = true;

    if (phone.split("")[0] !== "0") checkFirstChar = false;
    else checkFirstChar = true;

    if (phone.split("").some((a) => a === " ")) noSpace = false;
    else noSpace = true;

    // if (headArr.some((a) => a.includes(phone.slice(0, 3)))) checkHead = true;
    // else checkHead = false;

    return checkLength && checkChars && checkFirstChar && noSpace;
  };
}

export function getImageUrl(path: string | undefined, fallback: string) {
  if (!path) return fallback;

  const prefix = process.env.REACT_APP_API_URL || "";

  // encode từng phần để tránh lỗi
  const encodedPath = path.split("/").map(encodeURIComponent).join("/");

  // Nếu backend trả path đầy đủ (http://...), giữ nguyên prefix
  return path.startsWith("http") ? encodedPath : `${prefix}/${encodedPath}`;
}

export function setThemeColors(ticketBgColor?: string, primaryTextColor?: string, ticketHoverColor?: string, tableBorderColor?: string) {
  const root = document.documentElement;

  if (ticketBgColor) {
    root.style.setProperty("--background", ticketBgColor);
  }

  if (ticketHoverColor) {
    root.style.setProperty("--hover", ticketHoverColor);
  }

  if (tableBorderColor) {
    root.style.setProperty("--table-border", tableBorderColor);
  }

  if (primaryTextColor) {
    root.style.setProperty("--black-real", primaryTextColor);
  }
}

export function setFaviconAndTitle(logoUrl?: string, title?: string) {
  // Cập nhật favicon
  if (logoUrl) {
    const link: HTMLLinkElement =
      (document.querySelector("link[rel*='icon']") as HTMLLinkElement) ||
      document.createElement("link");
    link.type = "image/png";
    link.rel = "icon";
    link.href = logoUrl;
    document.getElementsByTagName("head")[0].appendChild(link);
  }

  // Cập nhật title
  if (title) {
    document.title = title;
  }
}

export function getTitleFromSubdomain(): string {
  try {
    const host = window.location.hostname;
    const firstSub = host.split(".")[0];

    if (!firstSub) return "";

    return firstSub.replace(/-/g, " ");
  } catch {
    return "";
  }
}
